import { useMemo } from 'react';

import { PDFViewer } from '@/new/components/pdf-viewer';
import { BoundingBox } from '@/types';

export const ChunkDocViewer = ({
  docId,
  chunkId,
  boundingBoxes,
}: {
  docId: string;
  chunkId: string;
  boundingBoxes: BoundingBox[];
}) => {
  const coordinates = useMemo(() => {
    return boundingBoxes
      .map((boundingBox) => ({
        ...boundingBox,
        id: chunkId,
      }))
      .toSorted((a, b) => a.pageNumber - b.pageNumber || a.top - b.top);
  }, [boundingBoxes, chunkId]);

  return (
    <div className="flex h-full flex-col">
      <div className="flex-grow overflow-hidden">
        <div className="relative h-full">
          <PDFViewer docId={docId} highlights={coordinates} highlightedFactId={chunkId} />
        </div>
      </div>
    </div>
  );
};
